<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>服务管理</el-breadcrumb-item>
      <el-breadcrumb-item>统计</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20" style="padding-top: 5px">
      <el-tabs v-model="activeName" @tab-click="condition = {}">
        <el-tab-pane label="请求渠道统计" name="channel"></el-tab-pane>
        <el-tab-pane label="请求数量统计" name="flows"></el-tab-pane>
        <el-tab-pane label="流程耗时统计" name="timeConsuming"></el-tab-pane>
        <el-tab-pane label="流程节点统计" name="flow"></el-tab-pane>
      </el-tabs>
      <channel v-if="activeName == 'channel'"></channel>
      <flows v-else-if="activeName == 'flows'" @tab="hanldeTabChange"></flows>
      <TimeConsuming v-else-if="activeName == 'timeConsuming'"></TimeConsuming>
      <flow v-else-if="activeName == 'flow'" :condition="condition"></flow>
    </div>
  </div>
</template>
<script>
import channel from './channel.vue'
import flows from './flows.vue'

import flow from './flow.vue'
import TimeConsuming from './time_consuming.vue'
export default {
  components: {
    channel,
    flows,
    TimeConsuming,
    flow,
  },
  data() {
    return {
      activeName: 'channel',
      condition: {},
    }
  },
  methods: {
    hanldeTabChange(e) {
      this.activeName = 'flow'
      this.condition = e
    },
  },
}
</script>

<style scoped>
/deep/.filter .el-form-item {
  min-width: 250px;
}
</style>